import { Grid2 } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import FormFields from "../FormFields";

export default function CityInput({
  label,
  name,
  value,
  isMobile,
  onChange,
  country,
  errors,
}: any) {
  const [options, setOptions] = useState([]);
  const [city, setCity] = useState(value);
  const [selectedCountry, setSelectedCounty] = useState(country);
  const ranOnce = useRef<boolean>(false);

  function handleCityChange(e: any) {
    const { value } = e.target;
    setCity(value);
  }

  useEffect(() => {
    if (!ranOnce.current || selectedCountry !== country) {
      ranOnce.current = true;
      setOptions([]);
      if (selectedCountry !== country) {
        setSelectedCounty(country);
        setCity(null);
      }
      const url = process.env.PUBLIC_URL + "/" + country + ".cities.json";
      fetch(url)
        .then((res) => res.json())
        .then((data) => {
          const formattedCities = data.map((city: any) => ({
            label: city.name,
            value: city.code,
          }));
          setOptions(formattedCities);
        });
    }
  }, [country]);

  useEffect(() => {
    if (value !== city) {
      onChange({
        target: {
          name: name,
          value: city,
        },
      });
    }
  }, [city]);

  return (
    <Grid2
      // key={`country-${selectedCountry}`}
      display={"grid"}
      gridTemplateColumns={"7fr 3fr"}
      gap={1}
      container
    >
      <FormFields.AutoComplete
        label={label}
        name={name}
        value={city}
        onChange={handleCityChange}
        getOptionLabel={(option: any) =>
          option ? option.label + " (" + option.value + ")" : ""
        }
        isMobile={isMobile}
        options={options}
        required
        {...errors}
      />
      <FormFields.TextInput
        name="postCode"
        value={city && typeof city === "object" ? city.value : ""}
        disabled
      />
    </Grid2>
  );
}
